module.exports = __webpack_public_path__ + "img/11.473700a0.png";